<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">
                    </div>
                    <div class="col text-center">
                        <div style="padding-top:20px; ">
                            <b>通知</b>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div style="display: inline-flex;">
                            <div class="text-center" style="color:#cdcdcd;padding-top:7px;" @click="readAll()">
                                <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                    <use xlink:href="/images/open_mail.svg#open_mail"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    すべて既読
                                </div>
                            </div>
                            <div style="width:15px;"></div>
                            <a class="libere-header-menu text-center" href="/setting/notification" style="text-decoration:none;">
                                <div class="" style="color:#cdcdcd;padding-top:7px;">
                                    <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                        <use xlink:href="/images/setting.svg#setting"></use>
                                    </svg>
                                    <div class="text-nowrap" style="font-size: 8px;">
                                        通知設定
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="wrap">
            <div class="container" style="margin-top:40px;">
                <div class="row">
                    <div class="col-12" v-for="info in infos" :key="info.id">
                        <div style="padding:10px;">
                            <div class="info_card" @click="read(info.id, info.link_url)">
                                <div class="row">
                                    <div class="col-1 px-0">
                                        <div style="padding:10px" v-if="info.type == 1">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/hart.svg#hart"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 2">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/hart.svg#hart"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 3">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/hart.svg#hart"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 4">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/dm.svg#dm"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 5">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/card.svg#card"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 6">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/footprint.svg#footprint"></use>
                                            </svg>
                                        </div>
                                        <div style="padding:10px" v-else-if="info.type == 7 || info.type == 8">
                                            <svg style="height:25px;width:25px;fill:#6B4EFF;">
                                                <use xlink:href="/images/hart.svg#hart"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col pc-0">
                                        <div style="padding:10px">
                                            <img :src="info.icon_url" class="img-rounded-luna">
                                            <div style="font-size:14px;" v-if="info.type == 1">
                                                {{ info.name }}さんがあなたにいいね！しました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 2">
                                                {{ info.name }}さんがあなたにみてね！しました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 3">
                                                {{ info.name }}さんとマッチングしました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 4">
                                                {{ info.name }}さんからのメッセージ
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 5">
                                                {{ info.name }}さんがカードに返信しました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 6">
                                                {{ info.name }}さんから足あとをもらいました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 7">
                                                {{ info.name }}さんがあなたにプレミアムメッセージ付きいいね!しました
                                            </div>
                                            <div style="font-size:14px;" v-else-if="info.type == 8">
                                                {{ info.name }}さんがあなたにイベント限定プレミアムメッセージ付きいいね!しました
                                            </div>
                                            <div style="font-size:14px;padding-top:5px;color:#6B4EFF;"
                                                v-if="info.type == 4 || info.type == 5">
                                                {{ info.info_detail | rmTag | omittedText }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                        <div style="color:red" v-if="info.is_view == false">●</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="count != 0">
                    <div class="col">
                        <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                            v-if="is_page && count != 0">
                            <a @click="fetchInfoMore()">もっとみる</a>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="is_load_under">
                    <div class="col text-center">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
            <br>
            <br>
        </div>
        <FooterMenu />
    </div>
</template>

<script>
import FooterMenu from './components/FooterMenu.vue';
import { omittedText, rmTag } from '../lib/infoFilters';

export default {
    components: {
        FooterMenu
    },
    data() {
        return {
            infos: [],
            count: 0,
            page: 1,
            is_load: true,
            is_load_under: false,
            is_page: true,
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        async read(id, url) {
            await axios.get("/api/information/read/" + id)
                .then((response) => {
                    localStorage.setItem('prev_type', 88)
                    window.location.href = url
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("既読処理に失敗しました")
                    }
                })
        },
        async readAll() {
            await axios.get("/api/information/read_all")
                .then((response) => {
                    this.page = 1
                    this.fetchInfo()
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("既読処理に失敗しました");
                    }
                })
        },
        async fetchInfo() {
            await axios.get("/api/information/list")
                .then((response) => {
                    this.infos = response.data.infos.data
                    this.count = response.data.count

                    if (this.count <= 9) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通知の取得に失敗しました");
                    }
                })
        },
        async fetchInfoMore() {
            this.is_load_under = true
            this.page++

            await axios.get("/api/information/list" + "?page=" + this.page)
                .then((response) => {
                    this.infos.push.apply(this.infos, response.data.infos.data)

                    if (response.data.infos.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通知の取得に失敗しました")
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)

            if (p < 1 && this.is_page) {
                this.fetchInfoMore()
            }
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchInfo()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました");
                    })
            }
            else {
                this.fetchInfo()
            }
        }
        else {
            this.fetchInfo()
        }
    },
    filters: {
        omittedText,
        rmTag
    },
    watch: {
        text_good_message: function (u) {
            if ([...u].length > 200) {
                this.is_set = false
            } else {
                this.is_set = true
            }
        },
    },
}
</script>
<style scoped>
.luna-search-header {
    position: fixed;
    width: 540px;
    top: 0;
    z-index: 999999;
    background: #fff;
}

.info_card {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 5px 20px;
    border-radius: 10px;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.img-rounded-luna {
    width: 40px;
    height: 40px;
    border-radius: 5px;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-search-header {
        width: 100%;
    }
}
</style>
